import Vue from 'vue'
import Loading from './Loading.vue'

const Mask = Vue.extend(Loading)

// 确保遮罩仅追加一次
const ensureMaskAppended = (el) => {
    if (!el || !el.mask) return
    if (!el.mask.parentNode) {
        el.appendChild(el.mask)
    }
}

const toggleLoading = (el, binding) => {
    if (binding.value) {
        Vue.nextTick(() => {
            ensureMaskAppended(el)
            el.instance.visible = true
        })
    } else {
        el.instance.visible = false
    }
}

export default {
    bind: (el, binding) => {
        const mask = new Mask({
            el: document.createElement('div'),
            data () {}
        })
        el.instance = mask
        el.mask = mask.$el
        el.maskStyle = {}
        // 保证父容器可作为定位参考
        const computed = window.getComputedStyle(el)
        if (computed.position === 'static') {
            el.style.position = 'relative'
        }
        binding.value && toggleLoading(el, binding)
    },
    inserted: (el) => {
        // 初次插入时保证只追加一次
        ensureMaskAppended(el)
    },
    update: (el, binding) => {
        if (binding.oldValue !== binding.value) {
            toggleLoading(el, binding)
        }
    },
    unbind: (el) => {
        // 移除遮罩并销毁实例，避免残留
        if (el.mask && el.mask.parentNode) {
            el.mask.parentNode.removeChild(el.mask)
        }
        el.instance && el.instance.$destroy()
    }
}